import { Download, ExternalLink } from 'lucide-react';
import { api } from '../api/client.js';
import Modal from './ui/Modal.jsx';

/**
 * Modale d'aperçu PDF inline (iframe sur /api/cra/files/:id/pdf).
 * Le PDF est servi par le backend avec auth via token en query string.
 */
export default function PdfPreviewModal({ craFileId, title = 'Aperçu du CRA', onClose }) {
  if (!craFileId) return null;
  const url = api.cra.fileUrl(craFileId);

  return (
    <Modal
      open
      onClose={onClose}
      title={title}
      size="lg"
      footer={
        <>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={linkButtonStyle}
            title="Ouvrir dans un nouvel onglet"
          >
            <ExternalLink size={14} /> Nouvel onglet
          </a>
          <a
            href={url}
            download
            style={linkButtonStyle}
            title="Télécharger le PDF"
          >
            <Download size={14} /> Télécharger
          </a>
          <button onClick={onClose} style={closeButtonStyle}>
            Fermer
          </button>
        </>
      }
    >
      <iframe
        src={url}
        title={title}
        style={{
          width: '100%',
          height: '70vh',
          border: '1px solid var(--glass-border)',
          borderRadius: 'var(--radius-sm)',
          background: '#fff',
        }}
      />
    </Modal>
  );
}

const linkButtonStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.35rem',
  padding: '0.5rem 0.9rem',
  background: 'var(--glass)',
  color: 'var(--text)',
  border: '1px solid var(--glass-border)',
  borderRadius: 'var(--radius-sm)',
  cursor: 'pointer',
  fontSize: '0.85rem',
  textDecoration: 'none',
};

const closeButtonStyle = {
  padding: '0.5rem 1rem',
  background: 'var(--primary)',
  color: '#fff',
  border: 'none',
  borderRadius: 'var(--radius-sm)',
  cursor: 'pointer',
  fontSize: '0.85rem',
  fontWeight: 600,
};
